import React from 'react'
import { Link } from 'react-router-dom'

export const Figure = ({ name, content }) => {
    return (
        // This is the figure
        <div className='w-[300px] h-full p-5 bg-[#100c1219] rounded-xl flex flex-col justify-center items-center gap-3'>
            {/* // This is the image */}
            <div className='rounded-full w-[50px] h-[50px] bg-blue-500 overflow-hidden'>

            </div>
            {/* // This is the title */}
            <h1 className='text-blue-500 font-semibold text-2xl'>
                {name}
            </h1>
            {/* // This is the description */}
            {content}
            {/* // This is the link Button */}
            <Link className='underline  font-semibold' to=''>
                Know more
            </Link>
        </div>
    )
}
